import { TRACK_IMPACT, availableStages, stageIcons } from '@/impactReports/impactReport.types';
import { hasAnalyticsAdminCapability } from '@/services/authorization.service';
import { doTrack } from '@/track/track.service';
import { Icon, Slider } from '@seeqdev/qomponents';

export interface ImpactReportSliderProps {
  setStageIdx: (stage: number) => void;
  stageIndex: number;
}

/**
 * This component renders the slider that determines how much of the Impact Report form is displayed.
 */
export const ImpactReportSlider = ({ setStageIdx, stageIndex }: ImpactReportSliderProps) => {
  const handleValueChange = (value: number[]) => {
    const nextStage = value[0];
    if (typeof nextStage !== 'number') return;
    setStageIdx(nextStage);
    doTrack(TRACK_IMPACT, 'Form Slider dragged', { stageIndex: nextStage });
  };
  const canReview = hasAnalyticsAdminCapability();
  const visualMaxStageIdx = availableStages.length - 1;
  const maxAccessibleStageIdx = canReview ? visualMaxStageIdx : availableStages.indexOf('quantify');

  const sliderValue = Math.min(stageIndex, visualMaxStageIdx);

  return (
    <div className="flexRowContainer width-370">
      <Slider
        rootExtraClassNames="SliderRoot"
        trackExtraClassNames="SliderTrack"
        rangeExtraClassNames="SliderRange"
        thumbExtraClassNames="SliderThumb"
        min={0}
        max={visualMaxStageIdx}
        maxAccessible={maxAccessibleStageIdx}
        step={1}
        value={sliderValue}
        onValueChange={handleValueChange}
      />

      {/* Display corresponding icon for the current step */}
      <div className="slider-legend">
        {stageIcons.map((icon, index) => (
          <div key={index} className={index === stageIndex ? 'icon-active' : 'icon'}>
            <Icon icon={icon} type={index > stageIndex ? 'gray' : 'theme'} />
          </div>
        ))}
      </div>
    </div>
  );
};
